import { createStore, compose } from "redux";

// import thunk from 'redux-thunk';

import reducers from "./reducer";

export function ConfigureStore(IntitialState = {}) {
  console.log("window.__REDUX_DEVTOOLS_EXTENSION ",window.__REDUX_DEVTOOLS_EXTENSION )
  const stores = createStore(
    reducers,
    IntitialState,
     compose(window.__REDUX_DEVTOOLS_EXTENSION__? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f)
  );

  return stores;
}
export const store = ConfigureStore();
